import { render } from "./IconVerticalThreeDots.vue?vue&type=template&id=6c0da53e"
import script from "./IconVerticalThreeDots.vue?vue&type=script&lang=ts"
export * from "./IconVerticalThreeDots.vue?vue&type=script&lang=ts"
script.render = render

export default script